import CarotekColors from "@carotek/utils/Colors";
import { manufacturingPartNumberStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsManufacturingPartNumber";
import { partNumberStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPartNumber";
import { css } from "styled-components";

Object.assign(manufacturingPartNumberStyles, {
    ...manufacturingPartNumberStyles,
    labelText: {
        size: 16,
        weight: "bold",
        css: css`
            margin-right: 0px;
            font-size: 13px;
            color: ${CarotekColors.grey13};
            font-weight: 400;
        `,
    },
    valueText: {
        size: 16,
        css: css`
            margin-bottom: 5px;
            font-size: 13px;
            color: ${CarotekColors.grey13};
            font-weight: 400;
            display: inline-block;
        `,
    },
});
